import { render } from "./SubCategoryEdit.vue?vue&type=template&id=4f5de234"
import script from "./SubCategoryEdit.vue?vue&type=script&lang=js"
export * from "./SubCategoryEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/documentation.probabilityworks.cloud/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__